import styled, { css } from 'styled-components'

export const Title = styled.div<{ $required?: boolean }>`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding: 16px 0 4px;
  ${(props) =>
    props.$required &&
    css`
      &::after {
        content: ' *';
        color: #f5222d;
      }
    `}
`
